import { UploadFile } from "@mui/icons-material";
import {
  Box,
  Button,
  CircularProgress,
  TextField,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useStorage } from "../hooks/useStorage";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";

const PDFUpload = ({ value, onChange }) => {
  const [tab, setTab] = useState("upload");
  const [file, setFile] = useState(null);
  const [pdfUrl, setPdfUrl] = useState(value || "");
  const [loading, setLoading] = useState(false);
  const [isUploaded, setIsUploaded] = useState(false);
  const { uploadFile, deleteFile } = useStorage();

  useEffect(() => {
    if (value) {
      setPdfUrl(value);
      if (value.startsWith("http")) {
        setTab("url");
      }
    }
  }, [value]);

  const handleFileChange = async (event) => {
    if (file) {
      await deleteFile(`pdf/${file.name}`);
    }

    const selectedFile = event.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setIsUploaded(false);
    }
  };

  const handleUrlChange = (event) => {
    const url = event.target.value;
    setPdfUrl(url);
    onChange(url);
  };

  const handleUpload = async () => {
    if (!file) return;
    setLoading(true);
    try {
      const url = await uploadFile(file, "pdf");
      setPdfUrl(url);
      onChange(url);
      setIsUploaded(true);
    } catch (error) {
      console.error("Upload failed", error);
    }
    setLoading(false);
  };

  const handleDelete = async () => {
    if (!file && !isUploaded) return;

    try {
      await deleteFile(`pdf/${file.name}`);
      setPdfUrl("");
      onChange("");
      setFile(null);
      setIsUploaded(false);
    } catch (error) {
      console.error("Delete failed", error);
    }
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={1}
      border="1px solid #ccc"
      borderRadius="8px"
      width="100%"
      mx="auto"
      className="upload_view p-3"
    >
      <Box display="flex" flexDirection="row" justifyContent="space-between">
        <ToggleButtonGroup
          color="primary"
          value={tab}
          exclusive
          onChange={(e, newValue) => setTab(newValue)}
          aria-label="Platform"
        >
          <ToggleButton size="small" value="upload">
            Upload PDF
          </ToggleButton>
          <ToggleButton size="small" value="url">
            Enter Path
          </ToggleButton>
        </ToggleButtonGroup>

        {(isUploaded && file && tab === "upload") && (
          <IconButton
            aria-label="delete"
            onClick={handleDelete}
            disabled={loading}
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        )}
      </Box>

      {tab === "upload" ? (
        <Box 
            display="flex" 
            flexDirection="row"  
            justifyContent={"space-between"} className="items-center gap-2">
          <Button
            variant="contained"
            component="label"
            startIcon={<UploadFile />}
          >
            Choose PDF
            <input
              type="file"
              hidden
              accept="application/pdf"
              onChange={handleFileChange}
            />
          </Button>

          {file && (
            <Typography variant="body2" color="textSecondary">
              {file.name}
            </Typography>
          )}

          <Button
            variant="contained"
            color="primary"
            onClick={handleUpload}
            disabled={loading || !file}
            startIcon={loading ? <CircularProgress size={20} /> : null}
          >
            Upload
          </Button>
        </Box>
      ) : (
        <TextField
          label="PDF URL"
          variant="outlined"
          fullWidth
          value={pdfUrl}
          onChange={handleUrlChange}
          placeholder="Enter PDF link"
        />
      )}
    </Box>
  );
};

export default PDFUpload;
